export const locale = {
  'ROWOPERATION' : {
    'SHOWONMAP' : 'Show on map',
    'DOWNLOADTRACK' : 'Download track',
    'DISBAND' : 'Disband',
  }
};
